import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';

export const Quote = ( el ) => {
	const ui = {
		el,
		swiper: el.querySelector('.quote__swiper-container'),
		swiperScrollbar: el.querySelector('.quote__swiper-scrollbar')
	};

	Swiper.use( [ Scrollbar ] );

	// Build responsive horizontal scroll swiper
	const swiperObj = new Swiper (ui.swiper, { 
		centeredSlides: false,
		loop: false,
		spaceBetween: 10,
		slidesPerView: 1,
		speed: 300,
		scrollbar: {
			el: ui.swiperScrollbar,
			draggable: true,
		},
		breakpoints: {			
			720: {
				slidesPerView: 1,
				spaceBetween: 40
			}
		}
	});
};

export default Quote;
